import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addtablesection',
  templateUrl: './addtablesection.component.html',
  styleUrls: ['./addtablesection.component.css']
})
export class AddtablesectionComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  pricetypeColl: any = [];
  tablesectionColl: any = [];
  tablesectionid: number = 0

  tablesectionform = new FormGroup({
    tablesectionid: new FormControl(0),
    tablesectionname: new FormControl('', Validators.required),
    pricetypeid: new FormControl(null),
    tablesectionorderno: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "TableSection";


  @Input() tablesectionname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.tablesectionid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.tablesectionform.reset();
      this.fnInitializeTablesection();

      if (this.tablesectionid > 0) {
        this.fngetTablesection();
      }
      this.fngetPricetype()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.tablesectionid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeTablesection() {
    this.tablesectionform.setValue({

      tablesectionid: 0,
      tablesectionname: '',
      pricetypeid: null,
      tablesectionorderno:null,
      inactive: false,
    })
  }
  fngetPricetype() {

    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          this.pricetypeColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetTablesection() {

    var data = {
      'tablesectionid': this.tablesectionid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTableSection(data)
      .subscribe(
        (res) => {
          this.tablesectionColl = res.json().result;
          var editdata = this.tablesectionColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.tablesectionform.valid) {
        this.saveloading = true
        //Check
        var data = {
          'tablesectionid': this.tablesectionid,
          'tablesectionname': this.tablesectionform.get('tablesectionname').value,
          'pricetypeid': this.tablesectionform.get('pricetypeid').value,
          'tablesectionorderno': this.tablesectionform.get('tablesectionorderno').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.tablesectionform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckTableSection(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.tablesectionform.get('tablesectionid').value > 0) {
                //Update Department
                this.fnSetTablesection(data);
              }
              else {
                //Insert Department
                this.fnInsertTablesection(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false

                this.tablesectionform.controls['tablesectionname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertTablesection(data) {

    this.appService.fnInsertTableSection(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The New Table Section has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.tablesectionid);

          this.emitData.emit(this.tablesectionid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTablesection(data) {

    this.appService.fnSetTableSection(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The Table Section has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.tablesectionid, data.tablesection);

          this.emitData.emit(this.tablesectionid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.tablesectionform.setValue({

      tablesectionid: deptBO.tablesectionid,
      tablesectionname: deptBO.tablesectionname,
      pricetypeid: deptBO.pricetypeid,
      tablesectionorderno:deptBO.tablesectionorderno,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
